const menu = {
    label: '• Sub Área',
    to: '/sol/subareas',
    rules: ['SOL-001'],
};

export default menu;
